import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		defaultMessage: 'Agile planning at scale',
		id: 'home-broadcast-widget.header',
		description: 'The title of the promotional message.',
	},
	cardDescription: {
		defaultMessage: 'Track progress and make real-time changes using Plans.',
		id: 'home-broadcast-widget.card-description',
		description: 'The content of the promotional message describing what it is about.',
	},
	ctaLink: {
		defaultMessage: 'Start your free trial',
		id: 'home-broadcast-widget.cta-link',
		description:
			'An internal link that redirects the user to the billing page where they can start a trial.',
	},
	footerTooltip: {
		defaultMessage:
			'Many people in your organization use the Timeline view. We think you’d find value in a cross-team planning tool like Plans, which is part of Jira Premium.',
		id: 'home-broadcast-widget.footer-tooltip',
		description:
			'Text displayed in the tooltip in the footer explaining why the user is seeing the promotional content.',
	},
});
